import React from "react";
import {CheckCircleIcon, ExclamationCircleIcon, XCircleIcon} from '@heroicons/react/24/outline'
import {XMarkIcon} from '@heroicons/react/20/solid'
import Toast from "@app/component/overlays/toaster/Toast";

type Props = {
    index: number,
    toast: Toast,
    onClose: (index: number) => any
}

const Toaster: React.FunctionComponent<Props> = ({index, toast, onClose}) => {

    return <div
        className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
        <div className="p-4">
            <div className="flex items-start">
                <div className="flex-shrink-0">
                    {toast.state === 'info' && <ExclamationCircleIcon className="h-6 w-6 text-blue-400" aria-hidden="true"/>}
                    {toast.state === 'success' && <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true"/>}
                    {toast.state === 'error' && <XCircleIcon className="h-6 w-6 text-rose-400" aria-hidden="true"/>}
                </div>
                <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-slate-900">{toast.title}</p>
                    <p className="mt-1 text-sm text-slate-500">{toast.text}</p>
                </div>
                <div className="ml-4 flex flex-shrink-0">
                    <button
                        type="button"
                        className="inline-flex rounded-md bg-white text-slate-400 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        onClick={() => onClose(index)}
                    >
                        <span className="sr-only">Close</span>
                        <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
};

export default Toaster;